import React from 'react';
import { QueryKey } from 'react-query';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterOperationTypeValue,
  UniversalFilterOperationTypeModes,
  UniversalFilterOperationTypeOnChange
} from './UniversalFilterOperationType.types';

import { useUniversalFilterOperationType } from './hooks/useUniversalFilterOperationType';

import { OperationsTypesMultiSelect } from '../../../../../main/operations/helpers/OperationsTypesMultiSelect';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

interface UniversalFilterOperationTypeProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterOperationTypeValue;
  i18nName: I18nText;
  autoFocus?: boolean;
  onChange: UniversalFilterOperationTypeOnChange;
}

function UniversalFilterOperationType({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  autoFocus,
  onChange
}: UniversalFilterOperationTypeProps) {
  const { modeOptions, filterState, handleModeChange, handleStatusesChange } =
    useUniversalFilterOperationType({
      filterStateCacheKey,
      filterValue,
      onChange
    });

  return (
    <UniversalFilterTemplate<UniversalFilterOperationTypeModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      <OperationsTypesMultiSelect
        key={filterState.mode}
        value={filterState.states || []}
        autoFocus={autoFocus}
        onChange={handleStatusesChange}
      />
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterOperationType;
